import {
  beforeFillOrderStatuses,
  beforeFillRxFillRequestStatuses,
  type OrderStatus,
  type RxFillRequestStatus,
} from '@truepill/tpos-types'

const isOrderAfterFill = (order: { status: OrderStatus; rxFillRequests: { status: RxFillRequestStatus }[] }): boolean =>
  !beforeFillOrderStatuses.has(order.status) ||
  order.rxFillRequests.some(rxFillRequest => !beforeFillRxFillRequestStatuses.has(rxFillRequest.status))

export default isOrderAfterFill
